/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonAuthSerieUserResponse,
    JsonAuthSerieUserResponseFromJSON,
    JsonAuthSerieUserResponseFromJSONTyped,
    JsonAuthSerieUserResponseToJSON,
} from './JsonAuthSerieUserResponse';

/**
 * 
 * @export
 * @interface ApiResultOfJsonAuthSerieUserResponse
 */
export interface ApiResultOfJsonAuthSerieUserResponse {
    /**
     * 
     * @type {JsonAuthSerieUserResponse}
     * @memberof ApiResultOfJsonAuthSerieUserResponse
     */
    data?: JsonAuthSerieUserResponse;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthSerieUserResponse
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfJsonAuthSerieUserResponse
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthSerieUserResponse
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfJsonAuthSerieUserResponse
     */
    result?: ApiResultOfJsonAuthSerieUserResponseResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfJsonAuthSerieUserResponseResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfJsonAuthSerieUserResponseFromJSON(json: any): ApiResultOfJsonAuthSerieUserResponse {
    return ApiResultOfJsonAuthSerieUserResponseFromJSONTyped(json, false);
}

export function ApiResultOfJsonAuthSerieUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfJsonAuthSerieUserResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : JsonAuthSerieUserResponseFromJSON(json['data']),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfJsonAuthSerieUserResponseToJSON(value?: ApiResultOfJsonAuthSerieUserResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': JsonAuthSerieUserResponseToJSON(value.data),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

